// @flow
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { grid } from '@finect/tabular-utils/grid';

export const FAQWrapper = styled.div`
  max-width: ${grid(9)}px;
  margin: 0 auto;
  ${({ margin }) => margin && `margin: ${margin};`}
`;

export const CategorySection = styled.div`
  margin-bottom: 48px;
`;

export const CategoryTitle = styled.h2`
  ${getFont(5)}
  font-weight: 600;
  color: ${({ theme }) => theme.colors.font};
  margin-bottom: 32px;
  margin-top: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid ${({ theme }) => theme.plus.primary};
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const FAQItem = styled.div`
  background: #fff;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid
    ${({ theme, isOpen }) => (isOpen ? theme.plus.primary : theme.colors.ui || '#eee')};
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    border-color: ${({ theme }) => theme.plus.primary};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
`;

export const FAQHeader = styled.div`
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

export const FAQQuestion = styled.h3`
  font-weight: 500;
  margin: 0;
  ${getFont(1.5, 'compact')}
  color: ${({ theme }) => theme.colors.font};
  flex: 1;
`;

export const FAQIcon = styled.div`
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  color: ${({ theme, isOpen }) => (isOpen ? theme.plus.primary : theme.colors.fontL)};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const FAQContent = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? '2000px' : '0')};
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0, 1, 0, 1);
  ${({ isOpen }) => isOpen && 'transition: all 0.5s ease-in-out;'}
`;

export const FAQAnswer = styled.div`
  padding: 0 24px 24px;
  color: ${({ theme }) => theme.colors.fontL};
  line-height: 1.6;
  font-size: 1rem;

  p {
    margin-bottom: 12px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: ${({ theme }) => theme.plus.primary};
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }

  ul {
    margin-bottom: 12px;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
    position: relative;
    list-style: none;
    padding-left: 20px;

    &::before {
      content: '•';
      color: ${({ theme }) => theme.plus.primary};
      position: absolute;
      left: 0;
      font-weight: bold;
    }
  }

  strong {
    color: ${({ theme }) => theme.colors.font};
    font-weight: 600;
  }
`;
